import { Controller } from 'react-hook-form'

export default function AuthInput({ control, name, placeholder, type, error }) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <div className="relative">
          <input
            {...field}
            type={type}
            className={`text-md focus:border-primary peer-focus:text-primary peer block min-h-[auto] w-full rounded-lg border border-gray-300 bg-gray-100 px-4 py-3 outline-none transition-all duration-200 ease-linear hover:border-gray-400 focus:border-gray-accent focus:outline-none focus:ring-0 focus:placeholder:opacity-0 sm:text-lg`}
            id={type}
            placeholder=""
          />
          <label
            htmlFor={type}
            className={`pointer-events-none absolute top-[6px] mb-0 max-w-[90%] origin-[0_0] truncate pt-[0.37rem] leading-[2.15] text-neutral-500 transition-all duration-200 ease-out ${
              field?.value && field?.value?.length > 0
                ? 'text-primary left-0 -translate-y-[2.75rem]'
                : 'left-3 peer-focus:left-0 peer-focus:-translate-y-[2.75rem]'
            } dark:text-neutral-400`}
          >
            {placeholder}
          </label>
          <div className="mt-1">
            <div className="h-5">
              {error && <span className="text-red-accent">{error}</span>}
            </div>
          </div>
        </div>
      )}
    />
  )
}
